import { Button, Input, Space } from "antd";
import { ICellRendererParams } from "ag-grid-community";
import { useState } from "react";
import { showToast } from "@/ts/modals";
import {
    internationalizeNumericValue,
    parseInternationalizedValue,
    updateProductMapping,
} from "@/ts/utils";
import { TProductMappingUpdateConfig, TUpdateConfigBulkProductMapping } from "@/ts/common-types";
import { FaCheck } from "react-icons/fa";
import { isNumber } from "underscore";

const CompliancePriceCellRenderer = (params: ICellRendererParams) => {
    const [inputValue, setInputValue] = useState<string | number>(
        internationalizeNumericValue(params.value ?? '')
    );

    const [previousValue] = useState<number | null>(params.value ?? '');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        const parsedInputValue = +parseInternationalizedValue(inputValue);
        try {
            if (parsedInputValue === params.value) {
                throw new Error("No change found in the request");
            } else {
                setLoading(true);
                const updateConfig: TUpdateConfigBulkProductMapping = {
                    sku_channel: [{
                        channel: params.data.channel_id as number,
                        sku: params.data.sku as string | number,
                    }],
                    update_params: {
                        compliancePrice: parsedInputValue,
                    },
                };

                const response = await updateProductMapping(updateConfig);
                if (!response.status) {
                    throw new Error(`${response.message}`);
                }

                setLoading(false);
                showToast(
                    "success",
                    `Compliane price successfully updated for ${params.data.sku}`
                );

                params.api.getRowNode(params.node.id).setData({
                    ...params.data,
                    [params.colDef.field]: parsedInputValue,
                });
            }
        } catch (err: any) {
            console.error(err.message);
            setLoading(false);
            showToast("danger", err.message);
        }
    };

    return (
        <>
            {params.node.rowPinned ? null : (
                <Space.Compact style={{ width: "100%" }}>
                    <Input
                        style={{
                            border: "1.5px solid #ccc",
                        }}
                        value={
                            inputValue === "0"
                                ? ""
                                : !isNumber(
                                    parseInternationalizedValue(inputValue)
                                )
                                    ? previousValue
                                    : inputValue
                        }
                        onChange={(e) => {
                            if (/^\d*\.?\d{0,2}$/.test(e.target.value)) {
                                setInputValue(e.target.value)
                            }
                        }}
                        placeholder="Enter price"
                        onFocus={() =>
                            setInputValue(
                                inputValue === "0"
                                    ? ""
                                    : parseInternationalizedValue(inputValue)
                            )
                        }
                        onBlur={() =>
                            setInputValue(
                                internationalizeNumericValue(inputValue)
                            )
                        }
                    />
                    <Button
                        type="default"
                        style={{ padding: "0 8px", backgroundColor: "#EBEBEB" }}
                        onClick={handleSubmit}
                        loading={loading}
                    >
                        <FaCheck className="text-primary" />
                    </Button>
                </Space.Compact>
            )}
        </>
    );
};

export default CompliancePriceCellRenderer;
